import BoostsOnTheGo from './svgs/boosts-on-the-go.svg';
import ChatSupport from './svgs/chat-support.svg';
import CoverageShield from './svgs/coverage-shield.svg';
import LightBulb from './svgs/lightbulb.svg';
import MedicalAssistance from './svgs/medical-assistance.svg';
import Siren from './svgs/siren.svg';
import SubmitClaims from './svgs/submit-claims.svg';
import TravelRewards from './svgs/travel-rewards.svg';

export type Item = {
  icon: Icon;
  title: string;
};

export type Icon = keyof typeof iconMap;
export const iconMap = {
  boostsOnTheGo: BoostsOnTheGo,
  medicalAssistance: MedicalAssistance,
  submitClaims: SubmitClaims,
  travelRewards: TravelRewards,
  coverageShield: CoverageShield,
  lightBulb: LightBulb,
  siren: Siren,
  chatSupport: ChatSupport,
} as const;
